import { defaultUnits, QuantitiesTypes } from 'common/enums/unit-templates.js';
import { KnowEdmTableData } from './table-enums.js';

export const surveyReportMap = new Map();

surveyReportMap.set(KnowEdmTableData.SurveyName, {
  key: KnowEdmTableData.SurveyName,
  unit: '',
  label: 'Survey run',
});

surveyReportMap.set(KnowEdmTableData.SurveyToolId, {
  key: KnowEdmTableData.SurveyToolId, // should be mapped to error models? or not
  unit: '',
  label: 'Tool model',
});

surveyReportMap.set(KnowEdmTableData.MdMin, {
  key: KnowEdmTableData.MdMin,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth from [md]',
});

surveyReportMap.set(KnowEdmTableData.MdMax, {
  key: KnowEdmTableData.MdMax,
  unit: defaultUnits.get(QuantitiesTypes.Depth),
  quantity: QuantitiesTypes.Depth,
  label: 'Depth to [md]',
});